var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card",attrs:{"id":"general"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_c('h4',[_vm._v("Thông tin chung")])])]),(_vm.infomation)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.infomation.intro)}}):_c('div',[_vm._v("Chưa có thông tin chung")])])
}
var staticRenderFns = []

export { render, staticRenderFns }